import _ from 'lodash';

import {
	REFRESH_PREVIOUS, PAGE_MGR_LOAD, PGE_MGR_REMOVE_PAGES, PAGE_MGR_CLEAR,
	PGE_MGR_EDIT_PAGE, PAGE_MGR_MAPPER, PAGE_MGR_MAPPER_DATA,
	PAGE_MGR_CLEAR_MAPPER, SAVE_PROPS, PAGE_MGR_SET,
} from '../actionTypes';
import { PageInfo, DataMapper, PageManager, DbToObject } from './state';

function penultimatePage(state: PageManager) {
	return state.pages[state.pages.length - 2];
}

export const mutations = {
	[REFRESH_PREVIOUS]: (state: PageManager, refreshPreviousPage = false) => {
		if (state.pages.length > 0) {
			state.pages[state.pages.length - 1].refresh = refreshPreviousPage;
		}
	},

	[SAVE_PROPS]: (state: PageManager, { props, stateKey }: { props: object, stateKey: string }) => {
		const page = state.pages.find((element) => element.name === stateKey);
		if (page && props) {
			page.props = props;
		}
	},

	[PAGE_MGR_SET]: (state: PageManager, page: PageInfo) => {
		const index = state.pages.findIndex((p) => p.storeModule === page.storeModule);
		if (index !== -1) {
			state.pages[index] = page;
		} else {
			state.pages.push(page);
		}
	},

	[PAGE_MGR_LOAD]: (state: PageManager, { name, path, storeModule, storeObject, id, props }: {
		name: string,
		path: string,
		storeModule: string | null,
		storeObject: string | null,
		id: number | null,
		props: object,
	}) => {
		const pageIndex = state.pages.findIndex((i) => i.name === name);
		let page = state.pages[pageIndex];
		if (pageIndex === -1 || pageIndex !== (state.pages.length - 1)) {
			page = new PageInfo(id, name, path, storeModule, storeObject, props);
			state.pages.push(page);
		} else {
			page.path = path;
		}
	},

	[PGE_MGR_REMOVE_PAGES]: (state: PageManager, { paths, index }: { paths?: string[], index?: number }) => {
		if (paths) {
			state.pages = state.pages.filter((item) => !paths.includes(item.path));
		} else if (index !== undefined) {
			state.pages = (index === -1) ? [] : state.pages.slice(0, index);
		}
	},

	[PGE_MGR_EDIT_PAGE]: (state: PageManager, { oldPath, page }: { oldPath: string, page: Partial<PageInfo> }) => {
		const statePage = state.pages.find((item) => item.path === oldPath)!;
		const index = state.pages.indexOf(statePage);
		state.pages[index] = { ...statePage, ...page };
	},

	[PAGE_MGR_CLEAR]: (state: PageManager) => {
		state.pages = [];
	},

	/**
	 * Used after corectly routed to next page, so we targed previous page.
	 * @param dataMapperName - mapper function name which should run after vue componnet is creadet
	 * @param dbToBaseMapper - mapper which map grid data to object.
	 */
	[PAGE_MGR_MAPPER]: (state: PageManager, { dataMapperName, dbToBaseMapper }: { dataMapperName: string, dbToBaseMapper: DbToObject }) => {
		const page = penultimatePage(state);
		page.dataMapper = new DataMapper(dataMapperName, dbToBaseMapper);
	},

	/**
	 * Used after selected data to map, so we target the previous page.
	 * @param mapperData - selected data to map
	 */
	[PAGE_MGR_MAPPER_DATA]: (state: PageManager, { mapperData }: { mapperData: object }) => {
		const page = penultimatePage(state);
		if (!_.isNil(page.dataMapper)) {
			page.dataMapper.data = mapperData;
		}
	},

	/**
	 * Clear mapper after using it.
	 */
	[PAGE_MGR_CLEAR_MAPPER]: (state: PageManager) => {
		_.last(state.pages)!.dataMapper = null;
	},
};
